// Заглушка пустого состояния (SPEC §4.7): нейтральный брендинг (юр. граница) — без проприетарных
// ассетов. Текст/подсказка/опц. действие. Используется на пустом списке/поиске/директории/чате.

import type { CSSProperties, ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  hint?: string
  action?: ReactNode
}

export function EmptyState({ title, hint, action }: EmptyStateProps): JSX.Element {
  const wrap: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--space-2)',
    height: '100%',
    minHeight: 0,
    padding: 'var(--space-6, 32px)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
  }
  return (
    <div data-empty-state="" style={wrap}>
      <div style={{ fontSize: 'var(--font-lg)', fontWeight: 'var(--weight-semibold)', color: 'var(--color-text)' }}>
        {title}
      </div>
      {hint ? <div style={{ fontSize: 'var(--font-sm)' }}>{hint}</div> : null}
      {action ? <div style={{ marginTop: 'var(--space-2)' }}>{action}</div> : null}
    </div>
  )
}
